module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal-void"
  }, [_c('reveal', {
    attrs: {
      "confirm": true
    },
    on: {
      "confirm": _vm.refundTransaction
    }
  }, [(_vm.buttons) ? _c('a', {
    staticClass: "button alert",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Refund")]) : _c('a', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Refund")]), _c('h2', [_vm._v("Do you really want to refund the transaction"), _c('strong', [_vm._v("TR" + _vm._s(_vm.transaction.id))])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 columns"
  }, [_c('label', [_vm._v("Amount"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refundFields.amount),
      expression: "refundFields.amount"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.refundFields.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.refundFields, "amount", $event.target.value)
      }
    }
  })])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a97c5d06!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/TransactionRevealRefund.vue
// module id = 2640
// module chunks = 1